/**
 * @generated SignedSource<<13c1feb33f51c1ccc93218f0a30a0a57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamDropdown_teams$data = ReadonlyArray<{
  readonly node: {
    readonly name: string | null;
    readonly id: string;
  } | null;
  readonly " $fragmentType": "TeamDropdown_teams";
}>;
export type TeamDropdown_teams$key = ReadonlyArray<{
  readonly " $data"?: TeamDropdown_teams$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamDropdown_teams">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TeamDropdown_teams",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamTypeEdge",
  "abstractKey": null
};

(node as any).hash = "dcc9577bdda4ff58599704d28a66776f";

export default node;
